// B2a / B4 — /phase/:module. Shows the module's real state for THIS workspace from the unified module registry
// (GET /api/modules/:key): Active (link to the workspace), Available to Activate, Externally Blocked or Not
// Implemented. Unknown keys render the not-found page.
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AdminAppShell } from "../design-system/shells/AdminAppShell";
import StatusChip from "../components/StatusChip";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";
import NotFound from "./NotFound";

const TEXT = {
  active: "This module is active for this workspace.",
  available_to_activate: "This module is built but not activated for this workspace.",
  not_implemented: "This module is not implemented.",
  externally_blocked: "This module is externally blocked.",
};

export default function ModuleStatusPage() {
  const { module } = useParams();
  const { user } = useAuth();
  const [mod, setMod] = useState(undefined);
  useEffect(() => {
    let live = true;
    setMod(undefined);
    api.get(`/modules/${encodeURIComponent(module)}`).then((r) => live && setMod(r.data)).catch(() => live && setMod(null));
    return () => { live = false; };
  }, [module]);
  if (mod === null) return <NotFound />;
  const label = mod?.label || "Module";
  return (
    <AdminAppShell title={label} user={user}
                   breadcrumbs={[{ label: "Owner Command Center", to: "/owner" }, { label, to: null }]}>
      <section className="max-w-3xl bg-white border border-erf-borderCream rounded-md p-5 space-y-3" data-testid={`module-status-${module}`}>
        {mod === undefined ? <p role="status" className="text-sm text-erf-dark/60">Checking status…</p> : (
          <>
            <StatusChip status={mod.state} testId="module-status-state" />
            <p className="text-sm font-nav text-erf-dark">{TEXT[mod.state]}</p>
            {(mod.reason || mod.note) && <p className="text-sm font-nav text-erf-dark/70">{mod.reason || mod.note}</p>}
            {mod.state === "active" && mod.to && (
              <Link to={mod.to} data-testid="module-status-open"
                    className="inline-flex min-h-[44px] items-center px-4 rounded-sm bg-erf-gold text-erf-dark font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-erf-dark">
                Open {label.split(" (")[0]}
              </Link>
            )}
          </>
        )}
      </section>
    </AdminAppShell>
  );
}
